import { ParseResult, Schema } from "@effect/schema";
import { ChainKey } from "../chain";
import { Address } from "../address";
import { Effect, pipe, String, Array } from "effect";
import { ProtocolKey } from "../protocol";

export type MarketUid = typeof MarketUid.Type;
export type MarketUidEncoded = typeof MarketUid.Encoded;

export const MarketUid = Schema.Struct({
  protocolKey: ProtocolKey,
  marketAddress: Address,
}).annotations({ identifier: "MarketUid" });

export type MarketUidFromString = typeof MarketUidFromString.Type;
export type MarketUidFromStringEncoded = typeof MarketUidFromString.Encoded;

export const MarketUidFromString = Schema.transformOrFail(
  Schema.String,
  MarketUid,
  {
    decode: (s, _, ast) =>
      pipe(
        Effect.gen(function* () {
          const tuple = pipe(s, String.split("-"));

          const protocolKey = yield* pipe(
            tuple,
            Array.get(0),
            Effect.andThen(Schema.validate(ProtocolKey))
          );

          const marketAddress = yield* pipe(
            tuple,
            Array.get(1),
            Effect.andThen(Schema.validate(Address))
          );

          return { protocolKey, marketAddress };
        }),
        Effect.mapBoth({
          onFailure: (error) => new ParseResult.Type(ast, s, error.message),
          onSuccess: (marketChainUid) => marketChainUid,
        })
      ),
    encode: ({ protocolKey, marketAddress }) => {
      const encoded = `${protocolKey}-${marketAddress}`;

      return Effect.succeed(encoded);
    },
  }
);
